import http from './http';
import type {
  ToplantiListeSatiri,
  ToplantiDetayi,
  ToplantiGovdesi,
  ToplantiNotu,
  ToplantiNotuAcmaGovdesi,
  ToplantiNotuDuzenlemeGovdesi,
  KullaniciSecenegi,
  GorevSuzgeci,
} from '../types/toplanti';

const API = '/api/toplantilar';

export const getToplantilar = () => http.get<ToplantiListeSatiri[]>(API);

export const getToplanti = (id: number | string) => http.get<ToplantiDetayi>(`${API}/${id}`);

export const toplantiAc = (govde: ToplantiGovdesi) => http.post<ToplantiDetayi>(API, govde);

export const toplantiGuncelle = (id: number | string, govde: ToplantiGovdesi) =>
  http.put<ToplantiDetayi>(`${API}/${id}`, govde);

export const toplantiSil = (id: number | string) => http.delete(`${API}/${id}`);

export const notAc = (toplantiId: number | string, govde: ToplantiNotuAcmaGovdesi) =>
  http.post<ToplantiNotu>(`${API}/${toplantiId}/notlar`, govde);

export const notGuncelle = (notId: number, govde: ToplantiNotuDuzenlemeGovdesi) =>
  http.put<ToplantiNotu>(`${API}/notlar/${notId}`, govde);

export const notSil = (notId: number) => http.delete(`${API}/notlar/${notId}`);

export const goreviKapat = (notId: number) => http.post<ToplantiNotu>(`${API}/notlar/${notId}/kapat`);

// `null` = sahipsiz bırak
export const goreviAktar = (notId: number, yeniSorumluId: string | null) =>
  http.post<ToplantiNotu>(`${API}/notlar/${notId}/aktar`, { yeni_sorumlu_id: yeniSorumluId });

export const getGorevler = (suzgec: GorevSuzgeci) =>
  http.get<ToplantiNotu[]>(`${API}/gorevler`, { params: { suzgec } });

export const getGorevSayaci = () => http.get<{ sayi: number }>(`${API}/gorevler/sayac`);

export const getToplantiKullanicilari = () => http.get<KullaniciSecenegi[]>(`${API}/kullanicilar`);

export const getSiparisinToplantiNotlari = (siparisId: number | string) =>
  http.get<ToplantiNotu[]>(`${API}/siparisler/${siparisId}/notlar`);

export const getMusterininToplantiNotlari = (musteriId: number | string) =>
  http.get<ToplantiNotu[]>(`${API}/musteriler/${musteriId}/notlar`);
